import { useEffect, useLayoutEffect, useState } from 'react';

import { DEFAULT_MODULOR_DOMAIN } from '../constants/modulorDomain';

import { BodyAttrsObserver } from './body-mutation-observer';

export const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState(false);

  useLayoutEffect(() => {
    const updateSize = () => {
      setIsMobile(window.innerWidth < 600);
    };
    window.addEventListener('resize', updateSize);
    return (): void => window.removeEventListener('resize', updateSize);
  }, []);

  return isMobile;
};

export const useAssetUrl = (image: string | undefined, size = 'mdpi') => {
  const {
    colorScheme: initialColorScheme,
    themeName: initialThemeName,
    modulorDomain: initialModulorDomain,
  } = document?.body?.dataset || {};

  const [colorScheme, setColorScheme] = useState(initialColorScheme || null);
  const [themeName, setThemeName] = useState(initialThemeName || null);
  const [modulorDomain, setModulorDomain] = useState(
    initialModulorDomain || DEFAULT_MODULOR_DOMAIN,
  );
  const [url, setUrl] = useState('');
  const [colorSchemePrefix, setColorSchemePrefix] = useState('');

  const DARK_PREFIX = 'dark_';
  const NAME_PATTERN = /^[a-zA-Z0-9_-]+$/;

  const isName = NAME_PATTERN.test(image);

  useEffect(() => {
    if (isName) {
      setColorSchemePrefix(colorScheme === 'dark' ? DARK_PREFIX : '');
    }
  }, [colorScheme, isName]);

  useEffect(() => {
    if (isName) {
      const formattedName = image?.replace(/-/g, '_').toLowerCase() ?? '';

      setUrl(
        `https://${modulorDomain}/assets/images/${themeName}/${size}/${colorSchemePrefix}img_${formattedName}.webp`,
      );
    } else {
      setUrl(image);
    }
  }, [image, themeName, colorSchemePrefix, colorScheme, isName, size, modulorDomain]);

  useEffect(() => {
    return BodyAttrsObserver.listen({
      'data-theme-name': setThemeName,
      'data-color-scheme': setColorScheme,
      'data-modulor-domain': setModulorDomain,
    });
  }, []);

  return url;
};
